import { Component, ElementRef, ViewChild, OnInit, OnDestroy, ChangeDetectorRef, HostListener } from '@angular/core';
import { OptionTag, SubLabelPosition, OptionCoordinates, IconPosition } from '../optiontag/optiontag.component';
import { InspirationMenu } from '../menu/inspiration-menu.component';
import { ResourceManager } from '../../../components/resource-manager/resource-manager.component';
import { environment } from '../../../../environments/environment';
import { Gtag } from 'angular-gtag';
import { DrawingLibrary } from '../../../components/drawing.library';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { OptionSelectorComponent } from '../optionselector/option-selector.component';
import { OptionSelectorService } from '../../services/option-selector.service';
import { DrawingScale } from './background-scale';
import { MouseState } from './mouse-state';
import { ActivatedRoute, Router } from '@angular/router';
import { InspirationRoomService } from '../../services/inspiration-rooms/inspiration-room.service';
import { InspirationRoomModel } from '../../../models/InspirationRoomModel';
import { InspirationRoomOptionModel, InspirationRoomOptionStyle } from '../../../models/InspirationRoomOptionModel';
import { ReplaySubject, Subscription } from 'rxjs';
import { Globals } from '../../../services/globals';
import { GlobalOptionModel } from '../../../models/GlobalOptionModel';
import { NgxUiLoaderService } from 'ngx-ui-loader'
import { AreasService } from '../../../services/areas.service';
import { Appointment, Area, Option } from '../../../engine/models/models';
import { Bounds } from 'ngx-img-cropper';
import { LocaleExceptionsService } from '../../../services/localeExceptions.service';
import { OptionEngine } from '../../../engine/option.engine';
import { Location } from '@angular/common'
import { ToastrService } from 'ngx-toastr';
import { BroadcastService } from '../../../services/broadcast.service';
import { InspirationReportComponent } from '../InspirationsReport/inspirations-report.component';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from '@angular/platform-browser';
import { InspirationRoomTipsModel } from '../../../models/InspirationRoomTipsModel';
import { InspirationRoomsResultModel } from '../../../models/InspirationRoomsResultModel';
import { AreaType, MouseButton } from '../../../enum';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { HttpParams } from '@angular/common/http';
@Component({
  selector: 'canvas-surface',
  templateUrl: './canvas-surface.component.html',
  styleUrls: ['./canvas-surface.styles.css'],
  host: {
    '(window:resize)': 'resizeCanvas($event)',
    '(window:orientationchange)': 'resizeCanvas($event)'
  }
})

export class SurfaceComponent implements OnInit, OnDestroy {
  @ViewChild('backgroundCanvas', { static: true }) backgroundCanvas: ElementRef;
  @ViewChild('foregroundCanvas', { static: true }) foregroundCanvas: ElementRef;

  // Subscriptions
  refreshOptionSubscription: Subscription;
  optionCreatedSubscription: Subscription;
  optionTipCreatedSubscription: Subscription;
  setBackButtonAreaNameSubscription: Subscription;
  addUpdateRoomOptionsSubscription: Subscription;
  addUpdateRoomTipSubscription: Subscription;
  routeChangedSubscription: Subscription;

  carousal: any[] = [];
  isArrow: boolean = false;
  refreshingOptions: boolean = false;

  backgroundImage: HTMLImageElement;
  //watermark: HTMLImageElement;
  option: GlobalOptionModel;
  availableOptions: GlobalOptionModel[];
  appointment: Appointment;
  currentInterval: number;
  id: number = 0;
  newOptionId = 0;
  newTipId = 0;
  isDesignerMode = false;
  isReady = false;
  stopDrawing = true;
  mouseDragFpsInterval: number;
  languageCode: string = 'en';
  searchValue: string = '';
  mouseState: MouseState;
  isTagShow: boolean = false;
  allSelected: boolean;
  selectBtnText: string = "SELECT ALL";
  menuWidth: number = 100;
  showSelectAll: boolean;
  selected: boolean = true;
  areas: Area[] = [];
  likedOptions: Option[] = [];
  bound: Bounds;
  engine: OptionEngine;
  globalOptions: any[] = [];
  loadRoom: boolean = true;
  changingRoom: boolean = false;
  IsNavigate: boolean = true;

  private backgroundScale: DrawingScale = new DrawingScale();
  private backgroundContext: CanvasRenderingContext2D;
  private foregroundContext: CanvasRenderingContext2D;
  private dragFps = 20; // The FPS to use when dragging an icon (to save CPU)
  private elapsed: number;
  private fpsInterval: number;
  private inspirationMenu: InspirationMenu;
  private maxFps = 30;
  private now: number;
  private optiontags: OptionTag[] = [];
  public selectedTags: OptionTag[] = [];
  private startTime: number;
  private then: number;
  private absoluteX: number;
  private absoluteY: number;

  private backgroundDrawn = false;
  localLanguage: any = [];
  allRooms: any = [];
  currentRooms: any;
  filteredRooms = [];
  localLanguageCodes: any = [];
  roomIndex = 0;
  roomKeys: string[] = [];
  roomScales: DrawingScale[] = [];
  selectedTag: OptionTag;
  swappedRoomImage: HTMLImageElement;
  singleEditMode: boolean;
  selectedRoom: InspirationRoomModel;
  swapRoomOpacity = 0;
  isSwappingRooms = false;
  //isFirstRoom = false;
  //isLastRoom = false;
  isAnyRoom: boolean = true;
  isAnyFilteredRoom: boolean = true;
  isAdminLogin: boolean;
  isFirstDraw: boolean = true;

  public backButtonAreaName: string;

  constructor(
    private cdr: ChangeDetectorRef, private location: Location,
    private route: ActivatedRoute,
    private gtag: Gtag,
    private optionSelector: MatBottomSheet,
    private inspirationRoomService: InspirationRoomService,
    private resourceManager: ResourceManager,
    private router: Router,
    private globals: Globals,
    private service: OptionSelectorService,
    private localeExceptionsService: LocaleExceptionsService,
    private loader: NgxUiLoaderService,
    private areasService: AreasService,
    private toastr: ToastrService, private broadcastService: BroadcastService,
    public dialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private $gaService: GoogleAnalyticsService) {

    if (JSON.parse(localStorage.getItem("userType")).isAdmin) {
      this.isAdminLogin = true;
      this.globals.getGlobalOptions(false).then(result => {
        this.globalOptions = result
      });
    }

    this.getAreas();
    this.preloadComponentImages();
    this.matIconRegistry.addSvgIcon("favorite-icon", this.domSanitizer.bypassSecurityTrustResourceUrl(environment.theme.btnFavoriteIcon));
    this.matIconRegistry.addSvgIcon("unfavorite-icon", this.domSanitizer.bypassSecurityTrustResourceUrl(environment.theme.btnUnfavoriteIcon));
    this.engine = new OptionEngine($gaService);
    this.optionCreatedSubscription = this.service.optionAdded.subscribe(option => {
      if (option) {
        if (option.id === 0) {
          this.newOptionId = option.optionId;
        }
        this.addOption(option);
      }
      else {
        this.getRoom();
      }
    });
    this.refreshOptionSubscription = this.service.refreshOption.subscribe(optionIds => {
      //this.selectedRoom.tips = this.selectedRoom.tips.filter(x => !optionIds.includes(x.id));
      this.selectedRoom.options = this.selectedRoom.options.filter(x => !optionIds.includes(x.optionId));
      this.optiontags = this.optiontags.filter(x => !optionIds.includes(x.optionId));
    })

    this.optionTipCreatedSubscription = this.service.addTip.subscribe(tip => {
      if (tip) {
        this.addTip(tip);
      }
    });

    const id = this.route.snapshot.params.id;
    this.globals.insperationalRoomId = id;

    this.setBackButtonAreaNameSubscription = this.broadcastService.subscribe("SetBackButtonAreaName", (backButtonAreaName) => {
      this.backButtonAreaName = backButtonAreaName;
    });
  }

  ngOnInit(): void {
    this.getRoom();

    this.localeExceptionsService.getLanguageCodes().subscribe(response => {
      this.localLanguageCodes = response;
    });
    this.toggleLikeUnlike();
  }

  // Unload/Cleanup
  @HostListener('unloaded')
  ngOnDestroy(): void {
    if (this.optionCreatedSubscription) this.optionCreatedSubscription.unsubscribe();
    if (this.optionTipCreatedSubscription) this.optionTipCreatedSubscription.unsubscribe();
    if (this.setBackButtonAreaNameSubscription) this.setBackButtonAreaNameSubscription.unsubscribe();
    if (this.addUpdateRoomOptionsSubscription) this.addUpdateRoomOptionsSubscription.unsubscribe();
    if (this.addUpdateRoomTipSubscription) this.addUpdateRoomTipSubscription.unsubscribe();
    if (this.routeChangedSubscription) this.routeChangedSubscription.unsubscribe();
    if (this.refreshOptionSubscription) this.refreshOptionSubscription.unsubscribe();
    localStorage.removeItem("AllRooms");
  }

  addOption(option: InspirationRoomOptionModel) {
    if (option.id > 0) {
      this.selectedRoom.options = this.selectedRoom.options.filter(x => x.id !== option.id);
    }
    if (this.absoluteX === undefined) { this.absoluteX = this.backgroundImage.width / 2 }
    if (this.absoluteY === undefined) { this.absoluteY = this.backgroundImage.height / 2 }
    option.absoluteX = this.absoluteX;
    option.absoluteY = this.absoluteY;
    //option.createdById = sessionStorage.getItem("userId");
    option.createdById = localStorage.getItem("userId");
    option.optionId = option.globalOptions.optionId;
    option.roomId = this.selectedRoom.id;
    this.loader.start();
    this.addUpdateRoomOptionsSubscription = this.inspirationRoomService.addUpdateRoomOptions(option).subscribe(result => {
      this.selectedRoom.options.push(result);
      this.initOrUpdateOptions();
    });
  }

  addTip(tip: InspirationRoomTipsModel) {
    if (tip.id > 0) {
      this.selectedRoom.tips = this.selectedRoom.tips.filter(x => x.id !== tip.id);
    }
    if (this.absoluteX === undefined) { this.absoluteX = this.backgroundImage.width / 2 }
    if (this.absoluteY === undefined) { this.absoluteY = this.backgroundImage.height / 2 }
    tip.absoluteX = this.absoluteX;
    tip.absoluteY = this.absoluteY;
    //option.createdById = sessionStorage.getItem("userId");
    tip.createdById = localStorage.getItem("userId");
    tip.inspirationRoomId = this.selectedRoom.id;
    this.loader.start();
    this.addUpdateRoomTipSubscription = this.inspirationRoomService.addUpdateRoomTip(tip).subscribe(result => {
      this.selectedRoom.tips.push(result);
      this.newTipId = result.id;
      this.initOrUpdateOptions();
    });
  }

  preloadComponentImages() {
    if (!this.resourceManager.isDefaultLoaded) {
      this.resourceManager.loadDefaultImages();
    }
  }

  formatProfileImageUrl(url: string) {
    // If the URL is null, simply return it.
    if (!url) { return url; }

    // Only add the host URL if it doesn't already include it
    if (url.includes("http") || url.includes("assets")) {
      return url;
    }
    return environment.userProfileImage + this.encode(url);
  }

  encode(imageUrl: string): string {
    imageUrl = imageUrl.replace(/\(/g, '%28');
    imageUrl = imageUrl.replace(/\)/g, '%29');
    return imageUrl;
  }

  getRoom() {
    this.loader.start();
    this.routeChangedSubscription = this.route.params.subscribe(params => {
      this.stopDrawing = false;
      this.globals.hideHeader = true;

      // Look for changes in the route and update as needed
      if (params["id"] && params["optionId"]) {
        this.singleEditMode = false;
        this.isDesignerMode = false;
        this.IsNavigate = false;
      }
      else if (params["id"]) {
        this.singleEditMode = true;
        this.isDesignerMode = true;
        this.id = +params["id"];
        this.languageCode = navigator.language;
      }
      else {
        this.singleEditMode = false;
        this.isDesignerMode = false;
      }

      // Request details on the room being viewed
      if (this.isDesignerMode) {
        if (!this.globals.allRooms.length) {
          this.globals.allRooms = JSON.parse(localStorage.getItem("AllRooms"));
        }
        this.inspirationRoomService.getRoomByRoomId(this.id, this.languageCode).subscribe(room => {
          if (room) {
            this.selectedRoom = room;
            this.globals.selectedCode = this.languageCode;
            if (this.optiontags.length > 0) {
              this.optiontags = [];
              this.initOrUpdateOptions();
            }
            else {
              this.initCanvas();
              this.loadLogo();
              this.initMenu();
              this.initAnimationThrottle();
            }
          }
        });
      }
      else {
        this.resourceManager.removeImage('SC-Image');
        if (this.globals && this.globals.engine && this.globals.engine.appointmentDetails && this.globals.engine.appointmentDetails.profileImage) {
          this.resourceManager.addImage('SC-Image', this.formatProfileImageUrl(this.globals.engine.appointmentDetails.profileImage), 2000);
        }
        this.globals.validateSession();
        this.initCanvas();
        this.loadLogo();
        this.initMenu();
        this.initAnimationThrottle();
      }
      this.checkAllSelected()
    });

    this.stopDrawing = false;
  }

  public filteredOptions: ReplaySubject<GlobalOptionModel[]> = new ReplaySubject<GlobalOptionModel[]>(1);

  filterOptions(search) {
    if (search === "") {
      return;
    }
    // get the search keyword

    if (!search) {
      this.filteredOptions.next(this.availableOptions.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredOptions.next(
      this.availableOptions.filter(options => options.description.toLowerCase().indexOf(search) > -1)
    );
  }

  private logo = new Image();

  // Logo no longer needed
  loadLogo() {
    if (!this.isDesignerMode && this.globals.engine === undefined) {
      requestAnimationFrame(() => this.loadLogo());
    }
    else {
      if (!this.logo.src) {
        this.logo.src = environment.theme.loadingLogoUrl;
        this.logo.onload = () => {
          this.initResources();
        };
      }
    }
  }

  updateOptionsWithLatestNaming(rooms: InspirationRoomsResultModel) {
    var allOptions = this.globals.engine.optionDefinitions;

    for (const room of rooms.rooms) {
      for (const option of room.options) {
      }
    }
  }

  initResources() {
    this.resetSurfaceParameters();
    // Only load resources that are needed
    if (this.singleEditMode) {
      if (!this.roomKeys.includes(this.selectedRoom.id.toString())) {
        this.roomKeys.push(this.selectedRoom.id.toString());
      }
      this.resourceManager.addImage(this.selectedRoom.id.toString(), this.selectedRoom.backgroundUrl, 2000);
    }
    else {
      if (this.globals.allRooms && this.globals.allRooms.length) {
        this.allRooms = JSON.parse(JSON.stringify(this.globals.allRooms));
        this.initRooms();
      } else {
        this.inspirationRoomService.listInspirationRooms().subscribe(response => {
          this.allRooms = response;
          this.globals.allRooms = JSON.parse(JSON.stringify(this.allRooms));
          this.initRooms();
        });
      }
    }
  }

  initRooms() {
    // Visualize the option in the Inspiration Room Viewer from selection page
    this.route.params.subscribe(params => {
      if (params["id"] && params["optionId"]) {
        this.tagShowHide();

        //uncomment the below code if need to Visualize only the pirticular selected option on the selection page
        this.allRooms.forEach((room) => {
          room.options = room.options.filter(function (option) {
            return option.optionId === parseInt(params["optionId"]);
          })
        })
        this.currentRooms = this.allRooms.find(room => room.id === parseInt(params["id"]));
        this.allRooms = this.allRooms.filter(room => room.id === parseInt(params["id"]));

        if (this.allRooms) {
          this.filterRooms(this.currentRooms.areaId, false);
        }
      }
      if (params["room"]) {
        this.tagShowHide();
        this.displayRoom(params["room"], false);
      }
      else {
        const availableOptionIds = this.globals.engine.allOptionAndStyleIds();
        if (availableOptionIds && this.currentRooms) {
          this.toggleLikeUnlike();

          this.currentRooms.options = this.currentRooms.options.filter(x => availableOptionIds.includes(x.optionId))

          this.allRooms.forEach(room => {
            room.options = room.options.filter(function (option) {
              return availableOptionIds.filter(function (optionId) {
                return optionId === option.optionId;
              }).length;
            });
          });

          this.allRooms = this.allRooms.filter(room => room.options.length > 0);

          if (this.currentRooms && this.currentRooms.options.length > 0) {
            this.filterRooms(this.currentRooms.areaId, false);
          }
        }
        else {
          this.loader.stop();
          this.isAnyRoom = false;
        }
      }
    });
  }

  getRoomIndex(roomId: string): number {
    this.filteredRooms = this.allRooms.filter(room => room.inspirationGroupId === this.globals.roomGroupId);
    if (this.filteredRooms && this.filteredRooms.length) {
      this.roomKeys = this.filteredRooms.map(x => x.id.toString())
    }
    return this.roomKeys.indexOf(roomId);
  }

  displayRoom(roomId, isSwap) {
    if (this.isFirstDraw && isSwap) {
      isSwap = false;
      this.isFirstDraw = false;
    }

    this.loadRoom = false;
    this.isArrow = false;
    if (this.globalOptions === undefined) {
      this.globalOptions = this.globals.globalOptions;
    }
    const availableOptionIds = this.globals.engine.allOptionAndStyleIds();

    if (availableOptionIds && this.allRooms.length) {
      this.allRooms.forEach(room => {
        room.options = room.options.filter(function (option) {
          return availableOptionIds.filter(function (optionId) {
            return optionId === option.optionId;
          }).length;
        });
      });
      this.allRooms = this.allRooms.filter(room => room.options.length > 0);
    }

    this.optiontags = [];
    this.roomKeys = [];
    this.isAnyFilteredRoom = false;
    if (!this.globals.roomGroupId) {
      if (this.allRooms.some(x => x.id == parseInt(roomId))) {
        this.globals.roomGroupId = this.allRooms.find(x => x.id == parseInt(roomId)).inspirationGroupId
      } else {
        this.location.back();
        this.router.navigate(['/inspirations']);
      }
    }
    this.filteredRooms = this.allRooms.filter(room => room.inspirationGroupId === this.globals.roomGroupId);
    for (const room of this.filteredRooms) {
      this.isAnyFilteredRoom = true;
      this.roomKeys.push(room.id.toString());
      this.resourceManager.addImage(room.id.toString(), room.backgroundUrl, 2000);
      this.selectedRoom = room;
      this.selectedRoom.tips = this.globals.engine.tips.filter(x => x.inspirationRoomId == this.selectedRoom.id)
      this.initOrUpdateOptions();
      this.isSwappingRooms = isSwap;
    }
    this.cdr.detectChanges();
    const index = this.roomKeys.indexOf(roomId);
    if (this.filteredRooms.length > 0) {
      this.loadRoom = true;
      this.roomIndex = index
      this.updateOptionTagVisibility();
    }
  }

  filterRooms(areaId, isSwap) {
    this.carousal = [];
    this.isArrow = false;
    if (this.globalOptions === undefined) {
      this.globalOptions = this.globals.globalOptions;
    }
    this.areas.map(function (area) {
      area.isSelected = false;
      if (area.id === areaId) {
        area.isSelected = true;
      }
    });

    this.optiontags = [];
    this.roomKeys = [];

    this.isAnyFilteredRoom = false;
    this.filteredRooms = this.allRooms;

    this.filteredRooms.forEach((room) => {
      this.isAnyFilteredRoom = true;
      this.roomKeys.push(room.id.toString());
      this.resourceManager.addImage(room.id.toString(), room.backgroundUrl, 2000);
      this.selectedRoom = room;
      this.initOrUpdateOptions();
      this.isSwappingRooms = isSwap;
    });
    this.cdr.detectChanges();
    if (this.filteredRooms.length > 0) {
      setTimeout(() => {
        this.carousal = this.filteredRooms;
        if (this.carousal.length > 5) {
          this.isArrow = true;
        }
      }, 1000);
    }
  }

  getAreas() {
    this.areasService.getAreas().subscribe(areas => {
      areas = areas.filter(x => x.areaType == AreaType.Area)
      for (const area of areas) {
        let areaIcon;
        let icon = area.areaIcon.split(" ");
        if (icon.length > 0) {
          icon = icon[0].split("-");
          const length = icon.length;

          for (let i = 1; i < length; i++) {
            if (!areaIcon) {
              areaIcon = icon[i];
            }
            else {
              areaIcon = areaIcon + "-" + icon[i];
            }
          }

          this.areas.push({
            id: area.id,
            name: area.name,
            isSelected: false,
            areaIcon: areaIcon,
            displayOrder: area.displayOrder,
            imageUrl: '',
            opacity: null,
            optionTotal: '',
            subAreas: null,
            isVisited: false,
            status: "NOT STARTED",
            areaHelpText: "",
            helpTextHidden: false,
            areaType: area.areaType
          });
        }
      }
    });
  }

  updateOptionsJson() {
    this.loader.start();
    this.appointment = JSON.parse(localStorage.getItem('appointment')) as Appointment;
    this.removeUnwantedProperties();
    this.appointment.options = this.globals.engine.optionDefinitions;
    this.inspirationRoomService.updateJson(this.appointment).subscribe(res => {
      this.globals.initializeOptionEngine(false, true);
    });
  }

  //In order to send the request, we have to remove the unwanted properties so that data can be mapped on server side.
  removeUnwantedProperties() {
    this.globals.engine.optionDefinitions.forEach((option) => {
      this.deleteProperty(option);
      if (option.childOptions) {
        option.childOptions.forEach((childOption) => {
          this.deleteProperty(childOption);
        });
      }
    });
  }

  deleteProperty(option: Option) {
    if (option.pictureUrl && option.pictureUrl.includes(environment.imageBaseUrl)) {
      option.pictureUrl = option.pictureUrl.substring(environment.imageBaseUrl.length);
    }
    if (option.hasOwnProperty("prepared")) {
      delete (option.prepared);
    }
    if (option.hasOwnProperty("selectedOption")) {
      delete (option.selectedOption);
    }
    if (option.hasOwnProperty("selectedPictureGallery")) {
      delete (option.selectedPictureGallery);
    }
    //if (option.hasOwnProperty("isVisible")) {
    //  delete (option.isVisible);
    //}
    if (option.hasOwnProperty("selectionRequired")) {
      delete (option.selectionRequired);
    }
  }

  initMenu() {
    if (!this.inspirationMenu) {
      this.inspirationMenu = new InspirationMenu();
      this.inspirationMenu.init(this.foregroundContext);
    }
  }

  initAnimationThrottle() {
    this.fpsInterval = 1000 / this.maxFps;
    this.mouseDragFpsInterval = 1000 / this.dragFps;
    this.currentInterval = this.fpsInterval;
    this.then = Date.now();
    this.startTime = this.then;
    this.stopDrawing = false;
    this.draw();
  }

  initCanvas(): void {
    this.resizeCanvas();
  }

  resizeCanvas(): void {
    // Get the canvas contexts
    this.backgroundContext = this.backgroundCanvas.nativeElement.getContext("2d", { alpha: true });
    const newCanvasWidth = window.innerWidth * 2;
    const newCanvasHeight = window.innerHeight * 2;

    // Store previous dimensions to calculate the scaling factor
    const prevWidth = this.backgroundContext.canvas.width;
    const prevHeight = this.backgroundContext.canvas.height;

    // Update canvas size
    this.backgroundContext.canvas.width = newCanvasWidth;
    this.backgroundContext.canvas.height = newCanvasHeight;
    this.backgroundContext.canvas.style.width = newCanvasWidth / 2 + "px";
    this.backgroundContext.canvas.style.height = newCanvasHeight / 2 + "px";
    this.backgroundContext.imageSmoothingEnabled = true;

    // Calculate the scaling factors
    const scaleX = newCanvasWidth / prevWidth;
    const scaleY = newCanvasHeight / prevHeight;

    // Update option tags' positions based on the scaling factors
    this.updateOptionTagsPosition(scaleX, scaleY, newCanvasWidth !== prevWidth, newCanvasHeight !== prevHeight);

    // Update foreground canvas similarly
    this.foregroundContext = this.foregroundCanvas.nativeElement.getContext("2d", { alpha: true });
    this.foregroundContext.canvas.width = newCanvasWidth;
    this.foregroundContext.canvas.height = newCanvasHeight;
    this.foregroundContext.canvas.style.width = newCanvasWidth / 2 + "px";
    this.foregroundContext.canvas.style.height = newCanvasHeight / 2 + "px";
    this.foregroundContext.imageSmoothingEnabled = true;

    // Refresh the drawing if the background image is available
    if (this.backgroundImage) {
      this.updateOptionTagVisibility();
    }
  }

  updateOptionTagsPosition(scaleX: number, scaleY: number, horizontalChange: boolean, verticalChange: boolean): void {
    this.optiontags.forEach(tag => {
      // Update scale only based on the dimension that has changed
      if (horizontalChange && !verticalChange) {
        // Only update horizontal scale for width changes
        tag.anchor.scale *= scaleX;
      } else if (!horizontalChange && verticalChange) {
        // Only update vertical scale for height changes
        tag.anchor.scale *= scaleY;
      } else {
        // Apply the smallest scaling factor for uniform scaling
        tag.anchor.scale *= Math.min(scaleX, scaleY);
      }

      // Recalculate relativeX and relativeY automatically based on the updated scale
      tag.updateAnchor(tag.anchor.absoluteX, tag.anchor.absoluteY, tag.anchor.scale, this.foregroundContext);
    });
  }



  loadLanguageCodes() {
    this.searchValue = '';
    this.localLanguage = this.localLanguageCodes;
  }

  changeLocalLanguage(code) {
    this.loader.start();
    this.router.navigate(['/edit/' + this.id + '/' + code]);
  }

  goToGallery() {
    // Prevent the application from any additional drawing
    this.stopDrawing = true;
    this.resetSurfaceParameters();
    this.router.navigate(['/gallery']);
  }

  resetSurfaceParameters() {
    // Reset default parameters
    this.isReady = false;
    this.backgroundImage = null;
    this.resourceManager.isInitalized = false;
  }

  isClickedOnShowHideOptions() {
    const xAnchor = 50;
    const yAnchor = this.foregroundContext.canvas.height - 140 - 50 - 4;

    if (this.mouseState.y > yAnchor && this.mouseState.y < yAnchor + 106
      && this.mouseState.x > xAnchor && this.mouseState.x < xAnchor + 500) {
      return true;
    }
    return false;
  }

  doubleClick(evt) {
    if (this.isClickedOnShowHideOptions()) {
      return;
    }

    if (this.isDesignerMode && this.globals.globalOptions) {
      this.globals.addedOptions = this.selectedRoom.options;

      if (this.selectedTag != null) {
        if (this.selectedTag.isDesignerTip) {
          this.globals.currentOptionId = 0;
          this.globals.selectedGlobalOption = undefined;

          this.globals.currentTipId = this.selectedTag.id;
          this.globals.selectedGlobalTip = this.selectedRoom.tips.find(x => x.id === this.selectedTag.id);
          this.absoluteX = this.selectedTag.absoluteX;
          this.absoluteY = this.selectedTag.absoluteY;
        } else {
          this.globals.currentTipId = 0;
          this.globals.selectedGlobalTip = new InspirationRoomTipsModel();

          this.globals.currentOptionId = this.selectedTag.id;
          this.globals.subLabel = this.selectedTag.subLabel;
          let optionId = this.selectedTag.selectedGlobalOption;
          this.globals.selectedGlobalOption = this.globals.globalOptions.find(x => x.optionId === this.selectedTag.selectedGlobalOption);
          //if not a parent or single option, then find from child options
          if (!this.globals.selectedGlobalOption) {
            this.globals.selectedGlobalOption = this.globals.globalOptions.find(opt => opt.childOptions?.some(item => item.optionId === optionId))?.childOptions.find(x => x.optionId == optionId);
          }
          let roomOption = this.selectedRoom.options.find(x => x.optionId == optionId);
          if (roomOption) {
            this.globals.selectedRoomOption = roomOption;
          }
          if (roomOption && roomOption.styleSelections && roomOption.styleSelections.length) {
            this.globals.selectedRoomOptionStyles = roomOption.styleSelections;
          }
          this.absoluteX = this.selectedTag.absoluteX;
          this.absoluteY = this.selectedTag.absoluteY;
        }
        this.openBottomSheet(false);
      }
      else {
        this.globals.currentOptionId = 0;
        this.globals.subLabel = "";

        this.globals.currentTipId = 0;
        this.globals.selectedGlobalTip = new InspirationRoomTipsModel();

        //this.globals.selectedGlobalOption = new Option;
        this.updateInputPosition(evt.layerX, evt.layerY);
        this.absoluteX = this.mouseState.x * this.backgroundScale.scaleWidth;
        this.absoluteY = this.mouseState.y * this.backgroundScale.scaleHeight;
        this.openBottomSheet(true);
      }
    }
  }

  openBottomSheet(isNew, defaultTipOpen = false): void {
    if (this.globals.globalOptions) {
      if (isNew) {
        this.globals.currentOptionId = 0;
        this.globals.addedOptions = this.selectedRoom.options;
        this.globals.addedTips = this.selectedRoom.tips;

        this.globals.currentTipId = 0;
        this.globals.defaultTip = defaultTipOpen;
        this.globals.selectedGlobalTip = new InspirationRoomTipsModel();
      }
      else {
        this.globals.defaultTip = defaultTipOpen;
        this.globals.currentOptionId = this.selectedTag.id;
      }

      this.optionSelector.open(OptionSelectorComponent, {
        panelClass: 'option-selector'
      });
    }
  }

  touchStart(evt) {
    if (this.isReady) {
      this.updateInputPosition(evt.touches[0].pageX, evt.touches[0].pageY - evt.target.offsetTop);
      this.inputDown(evt);
    }
  }

  touchEnd(evt) {
    if (this.isReady) {
      this.inputUp(evt);
    }
  }

  touchMove(evt) {
    if (this.isReady) {
      this.updateInputPosition(evt.touches[0].pageX, evt.touches[0].pageY - evt.target.offsetTop);
    }
  }

  mouseMove(evt) {
    if (this.isReady) {
      this.updateInputPosition(evt.layerX, evt.layerY);
    }
  }

  mouseDown(evt) {
    if (this.isReady) {
      this.updateInputPosition(evt.layerX, evt.layerY);
      this.inputDown(evt);
    }
  }

  mouseUp(evt) {
    this.updateInputPosition(evt.layerX, evt.layerY);
    if (this.isReady) {
      this.inputUp(evt);
    }
  }

  inputUp(evt: MouseEvent) {
    const xAnchor = 50;

    const yAnchor = this.foregroundContext.canvas.height - 140 - 50 - 4;

    if (this.mouseState.y > yAnchor && this.mouseState.y < yAnchor + 106
      && this.mouseState.x > xAnchor && this.mouseState.x < xAnchor + 500) {
      this.tagShowHide();

      return;
    }

    if (this.isReady) {
      this.mouseState.isDown = false;
      // Send update to server
      if (this.isDesignerMode && this.selectedTag) {
        this.updateBaseOption(this.selectedTag);
        this.inspirationRoomService.updateRoom(this.selectedRoom).subscribe(result => {
          this.initOrUpdateOptions();
          this.updateOptionTagVisibility();
        });
      }
      if (!this.isDesignerMode && this.selectedTag && this.selectedTag.isCoordinateInBounds(this.mouseState.x, this.mouseState.y)) {
        const selectedOptionId = this.selectedTag.selectedGlobalOption;
        const isLiked = this.selectedTag.selected;
        let obj = this;
        this.globals.engine.optionDefinitions.forEach((result) => {
          if (result.childOptions != null) {
            result.childOptions.filter(function (item) {
              if (item.optionId === selectedOptionId) {
                if (item.styleSelections && obj.selectedTag.styleSelections && obj.selectedTag.styleSelections.some(x => x.styleId > 0)) {
                  for (let styleSelection of item.styleSelections) {
                    let likedStyle = obj.selectedTag.styleSelections.find(x => x.styleSelectionId == styleSelection.optionId && x.styleId > 0).styleId;
                    if (likedStyle) {
                      styleSelection.styleChoices.find(x => x.optionId == likedStyle).isLiked = isLiked;
                    }
                  }
                }
                return item.isLiked = isLiked;
              }
            });
          }
          else {
            if (result.optionId === selectedOptionId) {
              if (result.styleSelections && obj.selectedTag.styleSelections && obj.selectedTag.styleSelections.some(x => x.styleId > 0)) {
                for (let styleSelection of result.styleSelections) {
                  let likedStyle = obj.selectedTag.styleSelections.find(x => x.styleSelectionId == styleSelection.optionId && x.styleId > 0).styleId;
                  if (likedStyle) {
                    styleSelection.styleChoices.find(x => x.optionId == likedStyle).isLiked = isLiked;
                  }
                }
              }
              return result.isLiked = isLiked;
            }
          }
        });
        this.toggleLikeUnlike();
      }
    }
  }

  toggleLikeUnlike() {
    this.likedOptions = [];

    let selectedTags = this.optiontags.filter(x => x.selected && !x.isDesignerTip);

    let selectedTagsIds = selectedTags.map(x => x.selectedGlobalOption)
    if (!this.globals || !this.globals.engine || !this.globals.engine.optionDefinitions) {
      return;
    }

    this.likedOptions = this.globals.engine.optionDefinitions.filter(x => x.isLiked);

    this.globals.engine.optionDefinitions.forEach((result) => {
      if (selectedTagsIds.includes(result.optionId)) {
        result.isLiked = true;
        this.likedOptions.push(result);
      }

      if (result.childOptions && result.childOptions.length) {
        result.childOptions.forEach((child) => {
          if (selectedTagsIds.includes(child.optionId)) {
            child.isLiked = true;
          }
          if (child.isLiked) {
            this.likedOptions.push(child);
          }
        });

        //const childLiked = result.childOptions.filter(x => x.isLiked === true);
        //if (childLiked.length > 0) {
        //  this.likedOptions.push(childLiked[0]);
        //}
      }
    });
  }

  updateBaseOption(tag: OptionTag) {
    if (tag.isDesignerTip) {
      for (const tip of this.selectedRoom.tips) {
        if (tip.id === tag.id) {
          tip.absoluteX = tag.anchor.absoluteX;
          tip.absoluteY = tag.anchor.absoluteY;
          tip.createdById = localStorage.getItem("userId");
        }
      }
    } else {
      for (const option of this.selectedRoom.options) {
        if (option.id === tag.id) {
          option.absoluteX = tag.anchor.absoluteX;
          option.absoluteY = tag.anchor.absoluteY;
          option.labelDirection = tag.iconPosition;
          // option.createdById = sessionStorage.getItem("userId");
          option.createdById = localStorage.getItem("userId");
        }
      }
    }
  }

  initSelectAllButton() {
    this.checkAllSelected();
    let elements = document.getElementsByClassName('menu-side-bar')
    if (elements && elements.length) {
      let sideMenu = elements[0] as HTMLElement
      if (sideMenu.clientWidth) {
        this.menuWidth = sideMenu.clientWidth
        this.showSelectAll = true;
      }
    }
    this.selectBtnText = "SELECT ALL";
    if (this.allSelected) {
      this.selectBtnText = "DESELECT ALL";
    }
  }

  checkAllSelected() {
    let currentRoomId = this.roomKeys[this.roomIndex];
    let currentRoomTags = this.optiontags.filter(x => x.selectedRoomId === currentRoomId && !x.isDesignerTip);
    this.selectedTags = currentRoomTags.filter(x => x.selected);
    if (currentRoomTags.map(x => x.selected).includes(false)) {
      this.allSelected = false;
    } else {
      this.allSelected = true;
    }
    //this.toastr.success("All Selected : " + this.allSelected)
  }

  toggleSelect() {
    let selectValue = true;
    this.checkAllSelected();
    let currentRoomId = this.roomKeys[this.roomIndex];
    let currentRoomTags = this.optiontags.filter(x => x.selectedRoomId === currentRoomId && !x.isDesignerTip);
    let currentRoomTagIds = currentRoomTags.map(x => x.id);
    if (this.allSelected) {
      selectValue = false;
    }
    for (const tag of this.optiontags) {
      if (currentRoomTagIds.includes(tag.id)) {
        tag.selected = selectValue;
      }
    }
    this.initSelectAllButton()
    this.toggleLikeUnlike();
  }

  inputDown(event: MouseEvent) {
    if (this.isReady) {
      this.mouseState.isDown = true;
      this.selectedTag = null;
      let targetFound = false;

      for (const tag of this.optiontags) {
        if (tag.selectedRoomId === this.roomKeys[this.roomIndex]) {
          if (!targetFound && ((!tag.isDesignerTip && ((!tag.isCollapsed && tag.isCoordinateInBounds(this.mouseState.x, this.mouseState.y)) || (tag.isCollapsed && tag.isIconClicked(this.mouseState.x, this.mouseState.y))))
            || (tag.isDesignerTip && tag.isIconClicked(this.mouseState.x, this.mouseState.y)))) {
            // delete option [Shift + Mouse_Left_Button]
            if (this.isAdminLogin && event.shiftKey && event.button == MouseButton.Left) {
              tag.isDeleted = true;
              break;
            }

            if (!this.isDesignerMode && tag.isCoordinateInBounds(this.mouseState.x, this.mouseState.y)) {
              if (tag.isDesignerTip && tag.isIconClicked(this.mouseState.x, this.mouseState.y)) {
                tag.isCollapsed = !tag.isCollapsed;
              }
              if (!this.globals.isReadOnly) {
                tag.selected = !tag.selected;
              }
              this.selectedTag = tag;
            }
            else {
              tag.selectedOffsetX = (this.mouseState.x - tag.anchor.relativeX) * this.backgroundScale.scaleWidth;
              tag.selectedOffsetY = (this.mouseState.y - tag.anchor.relativeY) * this.backgroundScale.scaleHeight;

              tag.isSelected = true;
              if (this.isTagShow) {
                this.collapseAllTags();
              }
              this.selectedTag = tag;
              tag.isCollapsed = false;
            }
            targetFound = true;
          }
          else if (this.isDesignerMode && this.mouseState && tag.bounds && this.mouseState.x >= tag.adminFlipBounds.x
            && this.mouseState.y >= tag.adminFlipBounds.y
            && this.mouseState.x <= tag.adminFlipBounds.x + tag.adminFlipBounds.width
            && this.mouseState.y <= tag.adminFlipBounds.y + tag.adminFlipBounds.height) {
            this.mouseState.isDown = false;
            tag.iconPosition = tag.iconPosition === IconPosition.left ? IconPosition.right : IconPosition.left;
            if (this.isDesignerMode) {
              tag.isCollapsed = false;
              if (tag.isDesignerTip) {
                let tip = this.selectedRoom.tips.find(x => x.id === tag.id);
                this.inspirationRoomService.addUpdateRoomTip(tip).subscribe(result => { });
              } else {
                let option = this.selectedRoom.options.find(x => x.id === tag.id);
                option.labelDirection = tag.iconPosition;
                this.inspirationRoomService.addUpdateRoomOptions(option).subscribe(result => { });
              }
            }
          }
          else {
            tag.isSelected = false;
          }
        }
      }

      var tagToRemove = this.optiontags.find(q => q.isDeleted);
      if (tagToRemove) {
        this.deleteOption(tagToRemove.id);
      }
    }
  }

  get hasNextRoom(): boolean {
    return this.roomIndex < (this.roomKeys?.length - 1);
  }
  get hasPrevRoom(): boolean {
    return this.roomIndex > 0;
  }

  get nextRoomId(): number {

    if (this.globals?.allRooms?.length) {
      if (this.id) {
        //.filter(x => x.isActive)
        let activeRoomsIds = this.globals.allRooms.map(x => x.id);
        let currentRoomIndex = activeRoomsIds.indexOf(this.id);
        if (currentRoomIndex < activeRoomsIds.length - 1) {
          return activeRoomsIds[currentRoomIndex + 1];
        }
      }
    }
    return 0;
  }

  get prevRoomId(): number {
    if (this.globals?.allRooms?.length) {
      if (this.id) {
        let activeRoomsIds = this.globals.allRooms.map(x => x.id);
        let currentRoomIndex = activeRoomsIds.indexOf(this.id);
        if (currentRoomIndex > 0) {
          return activeRoomsIds[currentRoomIndex - 1];
        }
      }
    }
    return 0;
  }

  goToNextRoom() {
    this.router.navigateByUrl('/edit/' + this.nextRoomId);
    this.changeRoom();
  }

  goToPrevRoom() {
    this.router.navigateByUrl('/edit/' + this.prevRoomId);
    this.changeRoom();
  }

  changeRoom() {
    this.backgroundImage = null;
    this.changingRoom = true;
    this.loadRoom = true;
    this.roomKeys = [];
    this.optiontags = [];
    this.logo = new Image();
    setTimeout(() => { this.getRoom() }, 500)
  }

  transition() {
    this.backgroundImage = null;
    this.loadRoom = true;
    this.updateOptionTagVisibility();
    this.draw();
  }

  nextRoom() {
    this.roomIndex = this.roomIndex + 1;
    this.transition();
  }

  prevRoom() {
    this.roomIndex = this.roomIndex - 1;
    this.transition();
  }

  swapRooms(swappedIndex: number) {
    if (swappedIndex + 1 > this.roomKeys.length) {
      swappedIndex = 0;
    }
    const swappedRoomKey = this.roomKeys[swappedIndex];
    this.selectedRoom = this.allRooms.find(x => x.id === parseInt(swappedRoomKey));

    if (this.selectedRoom.origin) {
      const roomOrigins = this.selectedRoom.origin.split(',');

      this.bound = new Bounds();
      this.bound.left = Number(roomOrigins[0]);
      this.bound.right = Number(roomOrigins[1]);
      this.bound.top = Number(roomOrigins[2]);
      this.bound.bottom = Number(roomOrigins[3]);
    }

    this.backgroundImage = this.resourceManager.getImage(swappedRoomKey);

    this.backgroundContext.globalAlpha = this.swapRoomOpacity;

    //picture should scaled in center
    const screenWidth = window.innerWidth * 2;
    const screenHeight = window.innerHeight * 2;
    const ratio = this.backgroundImage.height / this.backgroundImage.width;
    let drawWidth = (screenHeight / ratio);
    let drawHeight = screenHeight;

    let x = (this.foregroundContext.canvas.width - drawWidth) / 2;
    this.foregroundContext.clearRect(0, 0, screenWidth, screenHeight);

    //this.backgroundContext.drawImage(swappedRoom, this.bound.left, this.bound.top, this.bound.right - this.bound.left, this.bound.bottom - this.bound.top, 0, 0, drawWidth, drawHeight);
    this.backgroundContext.drawImage(this.backgroundImage, x, 0, drawWidth, drawHeight);

    this.backgroundContext.globalAlpha = 1 - this.swapRoomOpacity;

    this.swapRoomOpacity += .02;

    if (this.swapRoomOpacity >= 1) {
      this.swapRoomOpacity = 0;

      if (this.roomIndex + 1 >= this.roomKeys.length) {
        this.roomIndex = 0;
      } else {
        this.roomIndex++;
      }
      this.updateOptionTagVisibility();
      this.backgroundScale = this.roomScales[this.roomIndex];
      this.isSwappingRooms = false;
      this.backgroundContext.globalAlpha = 1;
      this.carousal.map(function (record) {
        record.isActive = false;
        if (record.id === Number(swappedRoomKey)) {
          record.isActive = true;
        }
      });
    }

    this.foregroundContext.globalAlpha = 1;
  }

  updateRoomScales() {
    // First Initalization (or if collection of background images change)
    if (this.roomKeys.length > 0
      && this.roomScales.length !== this.roomKeys.length) {
      this.roomScales = [];
      for (const key of this.roomKeys) {
        const backgroundImage = this.resourceManager.getImage(key);
        const scale = this.getDrawingScale(backgroundImage.width, backgroundImage.height);
        this.roomScales.push(scale);
      }
      if (this.roomScales.length && this.roomScales[this.roomIndex]) {
        this.backgroundScale = this.roomScales[this.roomIndex];
      }
      return;
    }

    // Update existing scaling
    for (let i = 0; i < this.roomKeys.length; i++) {
      const backgroundImage = this.resourceManager.getImage(this.roomKeys[i]);
      this.roomScales[i] = this.getDrawingScale(backgroundImage.width, backgroundImage.height);
    }
    if (this.roomScales.length && this.roomScales[this.roomIndex]) {
      this.backgroundScale = this.roomScales[this.roomIndex];
    }
  }

  updateOptionTagVisibility() {
    if (this.resourceManager.isDownloading) {
      requestAnimationFrame(() => this.updateOptionTagVisibility());
    } else {
      this.updateRoomScales();
      const roomKey = this.roomKeys[this.roomIndex];
      if (!this.isDesignerMode) {
        // Track that user viewed this inspiration room
        this.gtag.event('viewed_inspiration_room', {
          method: 'Instagram',
          event_category: 'inspiration_rooms',
          event_label: roomKey
        });
      }

      for (const tag of this.optiontags) {
        if (tag.optionCoordinates && tag.optionCoordinates.length > 0) {
          for (const coord of tag.optionCoordinates) {
            if (coord.id === roomKey) {
              tag.updateAnchor(coord.x, coord.y, this.backgroundScale.scale, this.foregroundContext);
              tag.selectedRoomId = roomKey;
              //tag.iconPosition = coord.iconPosition;
              break;
            }
          }
        }
      }
    }
  }

  getDrawingScale(imageWidth: number, imageHeight: number): DrawingScale {
    const screenWidth = window.innerWidth * 2;
    const screenHeight = window.innerHeight * 2;
    const ds = new DrawingScale();
    let ratio = 0;
    let scale = 0;
    let scaledWidth = imageWidth;
    let scaledHeight = imageHeight;

    // if (imageWidth > screenWidth) {
    ratio = screenWidth / imageWidth;
    // ratio = screenHeight / imageHeight;
    scale = ratio;
    scaledHeight = imageHeight * ratio;
    scaledWidth = imageWidth * ratio;
    // }

    if (scaledHeight < screenHeight) {
      const xOffset = scaledWidth;
      ratio = screenHeight / imageHeight;
      scale = ratio;
      scaledHeight = imageHeight * ratio;
      scaledWidth = imageWidth * ratio;
      ds.xClipping = xOffset - scaledWidth;
    }

    ds.drawWidth = scaledWidth;
    ds.drawHeight = scaledHeight;
    ds.scale = scale;
    // ds.scale = screenHeight / imageHeight;
    ds.actualHeight = imageHeight;
    ds.actualWidth = imageWidth;
    return ds;
  }

  draw() {
    // Short circuit if we leave the page/component
    if (!this.stopDrawing) {
      requestAnimationFrame(() => this.draw());
    }

    this.foregroundContext.textAlign = "left";
    this.updateCurrentInterval();

    if (this.resourceManager?.isInitalized && !this.resourceManager.isDownloading) {
      this.isReady = true;
      this.changingRoom = false;
    }

    this.now = Date.now();
    this.elapsed = this.now - this.then;

    if (this.elapsed > this.currentInterval) {
      this.then = this.now - (this.elapsed % this.currentInterval);
      this.foregroundContext.globalAlpha = 1;

      if (this.isReady && this.roomKeys.length > 0) {
        this.initializeBackgroundImage();
        this.initOptionsIfEmpty();

        this.foregroundContext.font = "28px 'Poppins', sans-serif";
        this.foregroundContext.fillStyle = "#000";

        this.foregroundContext.beginPath();

        if (this.backgroundImage && this.loadRoom) {
          this.drawBackgroundImage();
          this.loader.stop();

          let isHoveringHotspot = this.processTags();

          // Update cursor style based on interaction
          this.foregroundContext.canvas.style.cursor = isHoveringHotspot && !this.globals.isReadOnly ? "pointer" : "";

          this.drawCollapseButton();
          this.initSelectAllButton();
        }
      } else {
        this.drawLoadingScreen();
      }
    }
  }

  private updateCurrentInterval() {
    if (this.mouseState?.isDown && this.isDesignerMode) {
      this.currentInterval = this.mouseDragFpsInterval;
    } else {
      this.currentInterval = this.fpsInterval;
    }
  }

  private initializeBackgroundImage() {
    if (!this.backgroundImage) {
      this.roomIndex = Math.max(0, this.roomIndex); // Ensure roomIndex is non-negative
      this.backgroundImage = this.resourceManager.getImage(this.roomKeys[this.roomIndex]);
      this.updateRoomScales();
      this.backgroundScale = this.roomScales[this.roomIndex];
    }
  }

  private initOptionsIfEmpty() {
    if (this.optiontags.length === 0) {
      this.initOrUpdateOptions();
    }
  }

  private processTags(): boolean {
    let isHoveringHotspot = false;

    const anchorX = 50;
    const anchorY = this.foregroundContext.canvas.height - 140 - 50 - 4;

    for (const tag of this.optiontags.filter(tag => !tag.isDeleted)) {
      if (this.isSwappingRooms) {
        this.processTagSwappingRooms(tag);
      } else if (tag.selectedRoomId === this.roomKeys[this.roomIndex]) {
        isHoveringHotspot = this.processTagInteraction(tag, anchorX, anchorY) || isHoveringHotspot;
      }
    }

    return isHoveringHotspot;
  }

  private processTagSwappingRooms(tag: OptionTag) {
    let nextRoom = (this.roomIndex + 1) % this.roomKeys.length;
    const nextRoomCoords = tag.getCoordsForRoom(this.roomKeys[nextRoom]);
    const nextRoomScale = this.roomScales[nextRoom];

    if (tag.selectedRoomId === this.roomKeys[this.roomIndex] && nextRoomCoords) {
      tag.drawAlpha = environment.theme.unfocusedAlpha;
      const coords = this.getLineXYatPercent(tag.anchor.absoluteX, tag.anchor.absoluteY, nextRoomCoords.absoluteX, nextRoomCoords.absoluteY, this.swapRoomOpacity);
      tag.draw(this.foregroundContext, nextRoomScale.scale, this.isDesignerMode);
      tag.updateAnchor(coords.x, coords.y, nextRoomScale.scale, this.foregroundContext);
    } else if (tag.drawAlpha > 0) {
      tag.fadeOut(0);
      tag.draw(this.foregroundContext, this.backgroundScale.scale, this.isDesignerMode);
    }
  }

  private processTagInteraction(tag: OptionTag, anchorX: number, anchorY: number): boolean {
    let isHovering = false;

    if (this.mouseState) {
      this.updateTagPositionIfSelected(tag);
      isHovering = this.updateTagHoverState(tag, anchorX, anchorY);
    } else {
      tag.fadeIn(environment.theme.unfocusedAlpha);
    }

    tag.draw(this.foregroundContext, this.backgroundScale.scale, this.isDesignerMode);
    return isHovering;
  }

  private updateTagPositionIfSelected(tag: OptionTag) {
    if (this.mouseState.isDown && tag.isSelected && this.isDesignerMode) {
      const x = (this.mouseState.x * this.backgroundScale.scaleWidth) - tag.selectedOffsetX;
      const y = (this.mouseState.y * this.backgroundScale.scaleHeight) - tag.selectedOffsetY;
      tag.updateAnchor(x, y, this.backgroundScale.scale, this.foregroundContext);
    }
  }

  private updateTagHoverState(tag: OptionTag, anchorX: number, anchorY: number): boolean {
    const isHovering = (tag.isCoordinateInBounds(this.mouseState.x, this.mouseState.y) && !tag.isCollapsed) ||
      tag.isIconHover(this.foregroundContext, this.mouseState.x, this.mouseState.y) ||
      (this.mouseState.y > anchorY && this.mouseState.y < anchorY + 106 && this.mouseState.x > anchorX && this.mouseState.x < anchorX + 500);

    if (isHovering) {
      tag.fadeIn(environment.theme.focusedAlpha);
    } else if (tag.drawAlpha < environment.theme.unfocusedAlpha) {
      tag.fadeIn(environment.theme.unfocusedAlpha);
    } else if (!tag.isSelected) {
      tag.fadeOut(environment.theme.unfocusedAlpha);
    }

    return isHovering;
  }


  drawLoadingScreen() {
    // Need this from config
    this.foregroundContext.fillStyle = environment.theme.loadingBackgroundColor;
    this.foregroundContext.fillRect(0, 0, this.foregroundContext.canvas.width, this.foregroundContext.canvas.height);

    if (this.logo) {
      const drawWidth = this.foregroundContext.canvas.width / 3;
      const drawHeight = (drawWidth / this.logo.width) * this.logo.height;

      this.foregroundContext.drawImage(this.logo, (this.foregroundContext.canvas.width / 2) - drawWidth / 2, (this.foregroundContext.canvas.height / 2) - drawHeight / 2, drawWidth, drawHeight);

      // Placeholder for progress bar
      if (this.resourceManager
        && this.resourceManager.bytesTotal > 0) {
        this.foregroundContext.fillStyle = "#fff";
        this.foregroundContext.font = "20px 'Poppins', sans-serif";
        this.foregroundContext.textAlign = "center";
        this.foregroundContext.fillText(`${this.resourceManager.bytesRemaining}/${this.resourceManager.bytesTotal}`, (this.foregroundContext.canvas.width / 2), (this.foregroundContext.canvas.height / 2) + drawHeight + 20);
      }
    }
  }

  drawBackgroundImage() {
    if (!this.backgroundScale) {
      this.backgroundScale = new DrawingScale();
    }

    //picture should scaled in center
    const screenWidth = window.innerWidth * 2;
    const screenHeight = window.innerHeight * 2;
    const ratio = this.backgroundImage.height / this.backgroundImage.width;
    let drawWidth = (screenHeight / ratio);
    let drawHeight = screenHeight;
    let x = (screenWidth - drawWidth) / 2;

    this.foregroundContext.clearRect(0, 0, screenWidth, screenHeight);
    this.backgroundContext.clearRect(0, 0, screenWidth, screenHeight);
    if (this.selectedRoom.origin) {
      const roomOrigins = this.selectedRoom.origin.split(',');
      this.bound = new Bounds();
      this.bound.left = Number(roomOrigins[0]);
      this.bound.right = Number(roomOrigins[1]);
      this.bound.top = Number(roomOrigins[2]);
      this.bound.bottom = Number(roomOrigins[3]);
    }

    if (!this.isSwappingRooms && !this.backgroundDrawn && this.isDesignerMode) {
      this.backgroundContext.drawImage(this.backgroundImage, x, 0, drawWidth, drawHeight);
      this.backgroundDrawn = false;
    }
    //else if (this.isSwappingRooms) {
    //  // This occurs when a user is transitioning between viewing two rooms.
    //  this.swapRooms(this.roomIndex);
    //}

    if (!this.backgroundDrawn && !this.isDesignerMode) {
      this.backgroundContext.drawImage(this.backgroundImage, x, 0, drawWidth, drawHeight);
      this.backgroundDrawn = false;
    }

    //if (this.watermark) {
    //  this.foregroundContext.drawImage(this.watermark, this.foregroundContext.canvas.width - this.watermark.width - 40, this.foregroundContext.canvas.height - this.watermark.height - 80);
    //}
  }

  updateInputPosition(x: number, y: number) {
    x *= 2;
    y *= 2;

    if (!this.mouseState) {
      this.mouseState = new MouseState();
    }

    this.mouseState.x = x;
    this.mouseState.y = y;
    this.mouseState.scale = this.backgroundScale.scale;
  }

  initOrUpdateOptions(): void {
    // Load global options if not available (Only for Admin)
    if (!(this.globals && this.globals.globalOptions && this.globals.globalOptions.length) && this.isDesignerMode) {
      this.loader.start();
      this.globals.optionsService.getGlobalOptions(false).subscribe(response => {
        this.globalOptions = response;
        this.drawOptionsOnCanvas();
      });
    } else {
      this.drawOptionsOnCanvas();
    }
  }

  drawOptionsOnCanvas() {
    if (!this.changingRoom) {
      if (!this.selectedRoom.globalOptions) {
        this.selectedRoom.globalOptions = this.globals.globalOptions;
        this.globalOptions = this.globals.globalOptions;
      }
      if (this.selectedRoom.options?.length > 0) {
        for (const option of this.selectedRoom.options) {
          let isFound = false;

          for (const existingTag of this.optiontags) {
            if (existingTag.id === option.id) {
              isFound = true;
              this.updateOptionRoomCoordinates(option.id, this.selectedRoom.id.toString(), option.absoluteX, option.absoluteY);

              existingTag.label = this.engine.cleanVerbiage(option.displayName).toUpperCase();

              let optiondetail: any;
              if (this.globals && this.globals.engine && this.globals.engine.optionDefinitions && this.globals.engine.optionDefinitions.length) {
                optiondetail = this.globals.engine.optionDefinitions.find(opt => opt.childOptions?.some(item => item.optionId === option.optionId))?.childOptions.find(x => x.optionId == option.optionId);
              } else {
                if (this.selectedRoom.globalOptions && this.selectedRoom.globalOptions.length) {
                  optiondetail = this.selectedRoom.globalOptions.find(opt => opt.childOptions?.some(item => item.optionId === option.optionId))?.childOptions.find(x => x.optionId == option.optionId);
                }
              }
              //show display name if availabe
              if (optiondetail && optiondetail.displayName) {
                existingTag.label = this.engine.cleanVerbiage(optiondetail.displayName).toUpperCase();
              }

              existingTag.subLabel = option.subLabel;
              existingTag.isBoundsSet = false;
              existingTag.selectedGlobalOption = option.optionId;
              existingTag.absoluteX = option.absoluteX;
              existingTag.absoluteY = option.absoluteY;
              existingTag.isNewOption = false;

              this.foregroundContext.font = "30px 'Poppins', sans-serif";

              existingTag.labelWidth = this.foregroundContext.measureText(existingTag.label).width;

              if (existingTag.subLabel && existingTag.subLabel.length > 0) {
                this.foregroundContext.font = "28px 'Poppins', sans-serif";
                let sublabel = existingTag.subLabel.toUpperCase();
                existingTag.subLabelWidth = this.foregroundContext.measureText(sublabel).width;
              }
              let isActive = this.isAdminLogin && this.globals.getAllGobalOption().length ? this.globals.getAllGobalOption().map(x => x.optionId).includes(option.optionId) : true;
              existingTag.isActive = isActive;
              continue;
            }
          }

          if (!isFound) {
            if (!option.displayName || option.displayName === "") {
              let isOption = this.globals.globalOptions.find(x => x.optionId === option.optionId);
              if (isOption !== undefined) {
                option.displayName = isOption.description;
              }
            }
            let optionCoordinates = [];
            optionCoordinates.push({ id: this.selectedRoom.id.toString(), x: option.absoluteX, y: option.absoluteY, iconPosition: IconPosition.left });

            let isActive = this.isAdminLogin && this.globals.getAllGobalOption().length ? this.globals.getAllGobalOption().map(x => x.optionId).includes(option.optionId) : true;

            let optionTag = this.createOptionTag(option.id, option.optionId, option.absoluteX, option.absoluteY,
              optionCoordinates, option.displayName, option.subLabel, option.labelDirection, false, false,
              false, option.styleSelections, isActive)

            this.optiontags.push(optionTag);
          }
        }
      }

      if (this.selectedRoom.tips?.length > 0) {
        for (const tip of this.selectedRoom.tips) {
          let isFound = false;

          for (const existingTag of this.optiontags) {
            if (existingTag.id === tip.id) {
              isFound = true;
              this.updateOptionRoomCoordinates(tip.id,
                this.selectedRoom.id.toString(),
                tip.absoluteX,
                tip.absoluteY);

              existingTag.label = tip.title;

              existingTag.subLabel = tip.description;
              existingTag.isBoundsSet = false;
              existingTag.absoluteX = tip.absoluteX;
              existingTag.absoluteY = tip.absoluteY;
              existingTag.isNewOption = false;

              this.foregroundContext.font = "30px 'Poppins', sans-serif";
              existingTag.labelWidth = this.foregroundContext.measureText(existingTag.label).width;
            }
          }

          if (!isFound) {
            let tipCoordinates = [];
            tipCoordinates.push({ id: this.selectedRoom.id.toString(), x: tip.absoluteX, y: tip.absoluteY, iconPosition: IconPosition.left });
            let optionTag = this.createOptionTag(tip.id, 0, tip.absoluteX, tip.absoluteY, tipCoordinates, tip.title, tip.description, 0, false, false, true)
            this.optiontags.push(optionTag);
          }
        }
      }
      // Assign Options First Coordinates
      this.updateOptionTagVisibility();
    }
  }

  createOptionTag(id: number, optionId: number, absoluteX: number, absoluteY: number,
    coordinates: OptionCoordinates[],
    label: string,
    subLabel: string,
    labelDirection: number,
    selected: boolean,
    isCollapsed: boolean, isDesignerTip: boolean, styleSelections: InspirationRoomOptionStyle[] = null, isActive: boolean = true): OptionTag {

    const optionTag = new OptionTag(this.foregroundContext, this.resourceManager);
    optionTag.id = id;
    optionTag.isActive = isActive;
    optionTag.optionId = optionId;

    //if (styleSelections && styleSelections.length) {
    //  optionTag.styleSelections = styleSelections;
    //  // Check each styleSelection for inActive true
    //  for (let i = 0; i < styleSelections.length; i++) {
    //    const styleChoices = this.globals.getAllGobalOption()
    //      .filter(x => x.optionId === optionId)  // Filter by optionId
    //      .flatMap(x => x.styleSelections) // Flatten the styleSelections arrays
    //      .flatMap(x => x.styleChoices);
    //    ;

    //   // filteredData;
    //    //if (!styleChoices.some(choice => choice.optionId === styleSelections[i].styleId)) {
    //    //  //optionTag.inActive = true; // Set inActive to true if any styleSelection has inActive true
    //    //  break; // Exit loop early since we found an inActive true
    //    //}
    //  }
      
    //}

    optionTag.selectedRoomId = coordinates[0].id;

    if (isDesignerTip) {
      optionTag.isCollapsed = isCollapsed;
      optionTag.label = label;
      optionTag.subLabel = subLabel;
      optionTag.isDesignerTip = true;
    } else {
      if (label == null) {
        label = "";
      }
      else {
        optionTag.label = this.engine.cleanVerbiage(label).toUpperCase();
      }
      let optiondetail: any;
      if (this.globals && this.globals.engine && this.globals.engine.optionDefinitions && this.globals.engine.optionDefinitions.length) {
        optiondetail = this.globals.engine.optionDefinitions.find(x => x.optionId === optionId);
        //if not a parent or single option, then find from child options
        if (!optiondetail) {
          optiondetail = this.globals.engine.optionDefinitions.find(opt => opt.childOptions?.some(item => item.optionId === optionId))?.childOptions.find(x => x.optionId == optionId);
        }
      } else {
        if (this.selectedRoom.globalOptions && this.selectedRoom.globalOptions.length) {
          optiondetail = this.globals.globalOptions.find(x => x.optionId === optionId);
          //if not a parent or single option, then find from child options
          if (!optiondetail) {
            optiondetail = this.selectedRoom.globalOptions.find(opt => opt.childOptions?.some(item => item.optionId === optionId))?.childOptions.find(x => x.optionId == optionId);
          }
        }
      }
      //show display name if availabe
      if (optiondetail && optiondetail.displayName) {
        optionTag.label = this.engine.cleanVerbiage(optiondetail.displayName).toUpperCase();
      }

      if (!this.isDesignerMode) {
        if (!optiondetail) {
          optiondetail = this.globals.engine.optionDefinitions.find(opt => opt.optionId == optionId);
        }
        if (optiondetail) {
          optionTag.price = optiondetail.price;
        }
      }

      optionTag.selectedGlobalOption = optionId;
      if (optionTag.selectedGlobalOption === this.newOptionId) {
        optionTag.isCollapsed = false;
        optionTag.isNewOption = true;
      }
    }

    optionTag.iconPosition = labelDirection > 0 ? IconPosition.right : IconPosition.left;
    if (subLabel && subLabel.trim() !== "") {
      optionTag.subLabel = subLabel;
      optionTag.subLabelPosition = SubLabelPosition.bottom;
    }

    optionTag.selected = selected;
    //if (this.isTagShow) {
    //  optionTag.isCollapsed = true; //isCollapsed;
    //}
    optionTag.drawAlpha = 0;
    optionTag.optionCoordinates = coordinates;
    optionTag.absoluteX = absoluteX;
    optionTag.absoluteY = absoluteY;

    if (!this.isDesignerMode) {
      if (this.likedOptions.some(x => x.optionId === optionTag.selectedGlobalOption)) {
        let likedOption = this.likedOptions.find(x => x.optionId === optionTag.selectedGlobalOption)
        if (optionTag.styleSelections && optionTag.styleSelections.some(x => x.styleId > 0)) {
          for (let styleSelection of likedOption.styleSelections) {
            let currentStyleId = optionTag.styleSelections.find(x => x.styleSelectionId == styleSelection.optionId) != undefined ?
              optionTag.styleSelections.find(x => x.styleSelectionId == styleSelection.optionId).styleId : 0
            let likedStyles = styleSelection.styleChoices.filter(x => x.isLiked).map(x => x.optionId);
            if (!likedStyles.includes(currentStyleId)) {
              optionTag.selected = false;
              return optionTag;
            }
          }
          optionTag.selected = true;
        } else {
          optionTag.selected = true;
        }
      }
    }

    return optionTag;
  }

  drawCollapseButton() {
    const ctx = this.foregroundContext;
    const xAnchor = 100;
    const yAnchor = this.foregroundContext.canvas.height - 140;
    const radius = 50;
    const iconSize = radius * 1.25;

    ctx.globalAlpha = .2;

    ctx.fillStyle = environment.theme.primaryColor;
    ctx.globalAlpha = 1;

    DrawingLibrary.roundRect(ctx, xAnchor - radius, yAnchor - radius - 4, 500, (radius * 2) + 6, 58, true, false);

    if (this.isDesignerMode) {
      ctx.globalAlpha = .2;
    } else {
      ctx.globalAlpha = 1;
    }

    ctx.font = "38px 'Poppins', sans-serif";
    ctx.fillStyle = '#ffffffbb';
    ctx.globalAlpha = 1;

    ctx.fillStyle = "#fff";
    ctx.globalAlpha = 1;
    let optionText = "HIDE ALL OPTIONS";
    if (this.isTagShow) {
      optionText = "SHOW ALL OPTIONS";
    }
    ctx.fillText(optionText, xAnchor + radius + 20, yAnchor + 14);
    ctx.fillStyle = environment.theme.primaryColor;
    ctx.strokeStyle = "#fff";
    ctx.lineWidth = 4;
    ctx.beginPath();
    ctx.arc(xAnchor, yAnchor, radius, 0, 2 * Math.PI);
    ctx.fill();
    ctx.stroke();
    ctx.closePath();
    ctx.drawImage(this.resourceManager.getImage("tag-icon"), xAnchor - iconSize / 2, yAnchor - iconSize / 2, iconSize, iconSize);
  }

  drawBackButton() {
    const ctx = this.foregroundContext;
    const xAnchor = 100;
    const yAnchor = this.foregroundContext.canvas.height - 1550;
    const radius = 50;
    const iconSize = radius * 1.25;
    ctx.globalAlpha = .2;
    ctx.font = "38px 'Poppins', sans-serif";
    ctx.fillStyle = '#ffffffbb';
    ctx.globalAlpha = 1;
    ctx.fillStyle = environment.theme.primaryColor;
    ctx.strokeStyle = "#fff";
    ctx.lineWidth = 4;
    ctx.beginPath();
    ctx.arc(xAnchor, yAnchor, radius, 0, 2 * Math.PI);
    ctx.fill();
    ctx.stroke();
    ctx.closePath();
    ctx.drawImage(this.resourceManager.getImage("back-button"), xAnchor - iconSize / 2, yAnchor - iconSize / 2, iconSize, iconSize);
  }

  goToSelection() {
    this.router.navigate(["/selections"]);
  }

  tagShowHide() {
    if (!this.isTagShow) {
      this.collapseAllTags();
      this.isTagShow = true;
    }
    else {
      this.OpencollapseAllTags();
      this.isTagShow = false;
    }
  }

  collapseAllTags() {
    for (const tag of this.optiontags) {
      tag.isCollapsed = true;
    }
  }

  OpencollapseAllTags() {
    for (const tag of this.optiontags) {
      tag.isCollapsed = false;
    }
  }

  updateOptionRoomCoordinates(id: number, roomKey: string, absoluteX: number, absoluteY: number) {
    for (const option of this.optiontags) {
      if (option.id === id) {
        for (const coord of option?.optionCoordinates) {
          if (coord.id === roomKey) {
            coord.x = absoluteX;
            coord.y = absoluteY;
            return;
          }
        }
      }
    }
  }

  refreshGlobalOptionsJson() {
    this.refreshingOptions = true;
    this.service.getGlobalOptions(true).subscribe(response => {
      this.globals.globalOptions = response;
      this.selectedRoom.globalOptions = this.globals.globalOptions;
      this.globalOptions = this.globals.globalOptions;
      this.updateSelectedRoomOptions();
      this.refreshingOptions = false;
      this.optiontags= [];
      this.drawOptionsOnCanvas();      
      this.toastr.success(`All options have been refreshed with the latest available data.`, "Success!");
   

    });
  }

  updateSelectedRoomOptions() {
    for (let option of this.selectedRoom.options) {
      let updatedOption = this.globals.globalOptions.find(x => x.optionId == option.optionId);
      if (updatedOption) {
        option.displayName = updatedOption.displayName ? updatedOption.displayName : updatedOption.description
      }
    }
  }

  getLineXYatPercent(startX: number,
    startY: number,
    endX: number,
    endY: number,
    percent: number) {
    const dx = endX - startX;
    const dy = endY - startY;
    const X = startX + dx * percent;
    const Y = startY + dy * percent;
    return ({ x: X, y: Y });
  }

  goToBack() {
    this.stopDrawing = true;
    if (this.backButtonAreaName) {
      this.loader.start();
      this.router.navigate(['/selections']);
    }
    else {
      this.location.back();
      this.router.navigate(['/inspirations']);
    }
  }

  openInspirationReportDialog(event) {
    const reportDialog = this.dialog.open(InspirationReportComponent, {
      id: "inspiration-report",
      disableClose: true,
      minWidth: '60%',
      data: this.selectedRoom
    });
    reportDialog.afterClosed().subscribe(result => {
    });
  }

  deleteOption(id) {
    this.service.deleteOptions(id).subscribe(response => {
      this.selectedRoom.tips = this.selectedRoom.tips.filter(x => x.id !== id)
      this.selectedRoom.options = this.selectedRoom.options.filter(x => x.id !== id)
      this.optiontags = this.optiontags.filter(x => x.id !== id)
    });
  }

  deleteTip(id) {
    this.service.deleteTip(id).subscribe(response => {
      //this.service.loadOption(null);
      event.preventDefault();
    });
  }

  get getRoomOption(): boolean {
    let room = this.selectedRoom;

    if (room && room.options && room.options.length) {
      let optionsCount = room.options.length;
      let stylesCount = room.options.flatMap(x => x.styleSelections).length;
      room.totalTagsCount = optionsCount + stylesCount;

      let inactiveOptions = room.options.filter(x => !this.globals.getAllGobalOption().map(x => x.optionId).includes(x.optionId)).length;
      let styles = room.options.filter(x => x.styleSelections && x.styleSelections.length).flatMap(x => x.styleSelections.flatMap(q => q.styleSelectionId))
      let activeOptions = this.globals.getAllGobalOption().filter(x => room.options.map(x => x.optionId).includes(x.optionId))
      let availabeStyles = activeOptions.filter(x => x.styleSelections && x.styleSelections.length).flatMap(x => x.styleSelections.flatMap(q => q.optionId))

      let existStyleSelections = room.options.filter(x => x.styleSelections && x.styleSelections.length).flatMap(x => x.styleSelections)
      let currentActivStyles = activeOptions.filter(x => x.styleSelections && x.styleSelections.length).flatMap(x => x.styleSelections)

      let inactiveSelectedStyles = 0
      for (let styleSelection of existStyleSelections) {
        if (currentActivStyles.some(x => x.optionId == styleSelection.styleSelectionId) && styleSelection.styleId > 0) {
          let activeStyle = currentActivStyles.find(x => x.optionId == styleSelection.styleSelectionId)
          if (!activeStyle.styleChoices.some(x => x.optionId == styleSelection.styleId)) {
            inactiveSelectedStyles++;
          }
        }
      }

      let inactiveColorList = styles.filter(x => !availabeStyles.includes(x)).length;
      room.inactiveOptionCount = inactiveOptions + inactiveColorList + inactiveSelectedStyles;
      room.optionCountSet = true;
      room.hasInactiveOptions = room.inactiveOptionCount > 0;
      return true;
    }
    return false;
  }
  exportInspirationRoom(selectedRoom) {
    const params = new HttpParams()
      .set("roomId", this.selectedRoom.id);
    this.inspirationRoomService.exportInspirationRooms(params).subscribe(result => {
      const detailedReport: any = result.data;
      const linkSource = 'data:application/pdf;base64,' + detailedReport;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = result.fileName;
      downloadLink.click();
    });
  }
}
